import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  Heading,
  Image,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import CreacionBolsillo from '../../assets/images/start/creacion_bolsillo.png'
import PagoFactura from '../../assets/images/start/pago_factura.png'
import Recarga from '../../assets/images/start/recarga.png'

export default function StartModal({ isOpen, onClose }) {
  return (
    <Modal size="5xl" isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent borderRadius="15px">
        <ModalBody p="23px">
          <Heading textAlign="center" color="#74BF00" variant="h4">
            Bienvenido a la Plataforma Empresas de amiPASS
          </Heading>
          <Heading textAlign="center" variant="h5">
            Aprende lo necesario para gestionar el beneficio de alimentación
          </Heading>
          <HStack mt={70} mb={70}>
            <Box>
              <Flex justifyContent="center" mb={5}>
                <Image width={140} src={CreacionBolsillo} />
              </Flex>
              <Heading textAlign="center" color="#74BF00" variant="h6">
                Paso 1:
              </Heading>
              <Heading textAlign="center" color="#74BF00" variant="h5">
                Creación de bolsillo
              </Heading>
              <Text textAlign={'center'} mt={3}>
                Sigue el paso a paso para crear el bolsillo de tus colaboradores
              </Text>
              <Flex px={30} my={5}>
                <Link
                  isExternal
                  textDecorationLine="none"
                  href="/files/pdf/Manual Plataforma empresas bolsillo.pdf"
                  py={'10px'}
                  width={'100%'}
                  borderRadius={30}
                  textAlign={'center'}
                  backgroundColor="#74BF00"
                >
                  Ver más
                </Link>
              </Flex>
            </Box>
            <Box>
              <Flex justifyContent="center" mb={5}>
                <Image width={140} src={Recarga} />
              </Flex>
              <Heading textAlign="center" color="#74BF00" variant="h6">
                Paso 2:
              </Heading>
              <Heading textAlign="center" color="#74BF00" variant="h5">
                Recarga de Saldo
              </Heading>
              <Text textAlign={'center'} mt={3}>
                Aprende a cargar el beneficio en el bolsillo de tus
                colaboradores
              </Text>
              <Flex px={30} my={5}>
                <Link
                  isExternal
                  textDecorationLine="none"
                  href="/files/pdf/Manual Plataforma empresas recarga.pdf"
                  py={'10px'}
                  width={'100%'}
                  borderRadius={30}
                  textAlign={'center'}
                  backgroundColor="#74BF00"
                >
                  Ver más
                </Link>
              </Flex>
            </Box>
            <Box>
              <Flex justifyContent="center" mb={5}>
                <Image width={140} src={PagoFactura} />
              </Flex>
              <Heading textAlign="center" color="#74BF00" variant="h6">
                Paso 3:
              </Heading>
              <Heading textAlign="center" color="#74BF00" variant="h5">
                Pago de la factura
              </Heading>
              <Text textAlign={'center'} mt={3}>
                Flujo y datos de cuenta corriente al que se debe realizar el
                pago
              </Text>
              <Flex px={30} my={5}>
                <Link
                  isExternal
                  textDecorationLine="none"
                  href="/files/pdf/Manual Plataforma empresas pago de factura.pdf"
                  py={'10px'}
                  width={'100%'}
                  borderRadius={30}
                  textAlign={'center'}
                  backgroundColor="#74BF00"
                >
                  Ver más
                </Link>
              </Flex>
            </Box>
          </HStack>
        </ModalBody>
        <ModalFooter p="0px" h="0px" w="100%">
          <Center h="56px" w="100%">
            <Button
              h="56px"
              w="247px"
              borderRadius={30}
              onClick={onClose}
              variant="solid"
              type="button"
              colorScheme="blue"
              _hover={{
                backgroundColor: '#EFA329',
              }}
            >
              CERRAR VENTANA
            </Button>
          </Center>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

StartModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onContinue: PropTypes.func,
  size: PropTypes.string,
  textButton: PropTypes.string,
  title: PropTypes.string,
  noButton: PropTypes.bool,
}
